module.exports = new __parcel__URL__("the-stanley-parable.650dafe6.jpg").toString();